module.exports = __webpack_public_path__ + "static/step_03_副本.f80047c8.png";